<template lang="pug">
    .contact-container
        .contact-content
            .title {{ $t('留下联系方式，获取更多信息') }}
            el-button(
                @click="onClick"
            ) {{ $t('咨询合作')}}
</template>
<script>
export default {
  methods: {
    onClick () {
      this.$router.push('/contact?redirectUrl=' + this.$route.path + '&buttonName=咨询合作')
    }
  }
}
</script>

<style lang="stylus">
@media (max-width: 767px)
  .contact-container
    height 210px
    background-image url(../assets/mobile-contact-bg.png)
    .contact-content
      .title
        font-size 24px
        margin-bottom 20px
      .el-button
        width 144px
        height 36px
        font-size 14px
        font-weight 500
@media (max-width: 1370px) and (min-width: 768px)
  .contact-container
    height 370px
    background-image url(../assets/contact-bg.png)
    .contact-content
      .title
        margin-bottom 34px
        font-size 42px
      .el-button
        width 163px
        height 48px
        font-size 20px

.contact-container
  background-size 100% 100%
  display flex
  align-items center
  justify-content center
  .contact-content
    display flex
    flex-direction column
    align-items center
    justify-content center
    .title
      display block
      font-weight 600
      color #ffffff
    .el-button
        border-radius 25px
        background-color #ffffff
        border-color #ffffff
        color #478bca
        font-weight normal
</style>
